<template>
	<div class="a-flex-rfsc a-ptb-12"  >
		<div class="s-search-label a-flex-rfec " style="min-width: 82px;white-space: nowrap;" v-show="label">
			<span class="a-c-red a-fs-14" v-if="notnull">*</span>
			<div>{{label}}</div>
		</div>
		<el-input class="a-ml-10 a-flex-1" type="number" :class="large?'s-large-input':'s-nomarl-input'" 
			:placeholder="placeholder" :value="value" @input="handlerChange" min="0">
		</el-input>
	</div>
	
</template>

<script>
	export default {
		props:{
			label:{
				type:String
			},
			value:{
				required:true,
				default:''
			},
			placeholder:{
				type:String,
				default:'请输入'
			},
			notnull:{
				type:Boolean,
				default:false,
				required: false,
			},
			/**
			 * 是否为较长的输入框
			 */
			large:{
				type:Boolean,
				required:false,
				default:false
			},
		},
		data() {
			return {
			}
		},
		methods:{
			handlerChange(e){
				console.log('handlerChange',e)
				this.$emit('input',e)
			},
		}
	}
</script>
